import { BallotRounded, FeaturedPlayListRounded, HandshakeRounded, LibraryAddCheckRounded } from '@mui/icons-material'
import { Box, SvgIcon } from '@mui/material'
import React from 'react'

const TinyMceSVGIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 12 13'>
      <path fillRule='evenodd' clipRule='evenodd' d='M7.89267 0.5C9.89229 0.511788 11.8684 2.17387 11.8684 4.59627C11.8684 4.59627 11.8814 5.24334 11.8823 6.01369L11.8824 6.16257C11.8822 6.32937 11.8814 6.50024 11.8798 6.67012L11.8787 6.7719C11.8712 7.41521 11.8506 8.02982 11.8037 8.3389C11.5273 10.1896 10.1452 11.4686 8.23966 11.7927C6.52234 12.1287 5.50489 12.3232 5.17554 12.388C5.09251 12.4054 4.84261 12.441 4.59582 12.4675L4.54655 12.4727C4.391 12.4885 4.24123 12.5 4.14044 12.5C2.04672 12.5 0.147082 10.9322 0.117676 8.40373L0.117727 8.27717C0.117731 8.27094 0.117736 8.2645 0.11774 8.25786L0.117791 8.19272C0.118057 7.88759 0.11893 7.29303 0.121807 6.687L0.122507 6.54707L0.123015 6.45394C0.126429 5.84953 0.132026 5.26929 0.141201 4.99116C0.211776 3.14637 1.488 1.65521 3.91696 1.1778L3.92047 1.17712C4.03462 1.15492 6.88945 0.599725 7.01049 0.576621C7.29279 0.523576 7.60449 0.5 7.89267 0.5ZM9.29241 2.65128L4.58742 3.56483V5.40373L2.70542 5.76916V10.3546L7.41041 9.44106V7.60216L9.29241 7.23674V2.65128ZM7.41041 4.8556V7.60216L4.58742 8.15029V5.40373L7.41041 4.8556Z' />
    </SvgIcon>
  )
}

const DraftJSSVGIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 10 14'>
      <path d='M9.97623 5.36834V5.35271C9.97623 5.33155 9.97094 5.3158 9.97094 5.29476L9.95495 5.23151C9.95495 5.22622 9.94954 5.22622 9.94954 5.22105C9.94412 5.20001 9.93342 5.18414 9.92272 5.16839V5.1631C9.91321 5.14485 9.90248 5.12725 9.89062 5.11044L9.8798 5.09998C9.86704 5.08289 9.85271 5.06703 9.83699 5.0526L7.58726 2.84207L5.33741 0.631538C5.3213 0.615787 5.30531 0.605206 5.2892 0.589455L5.27838 0.579115C5.26239 0.568534 5.24099 0.557954 5.22487 0.547493H5.21958C5.20347 0.536912 5.18207 0.531742 5.16596 0.526452C5.16067 0.526452 5.16067 0.521161 5.15526 0.521161L5.09105 0.50529C5.06953 0.5 5.05354 0.5 5.03214 0.5H0.500334C0.232448 0.5 0.0181885 0.710412 0.0181885 0.973728V12.0263C0.0181885 12.2893 0.232448 12.5 0.500334 12.5H9.49961C9.76738 12.5 9.98176 12.2893 9.98176 12.0263V5.38421C9.97635 5.37892 9.97623 5.37363 9.97623 5.36834ZM5.47665 4.24209V2.11056L6.56406 3.17897L5.47665 4.24209ZM7.24435 3.84207L8.33176 4.91048H6.16235L7.24435 3.84207ZM0.977068 1.43688H4.51248V4.91048H0.977068V1.43688ZM0.977068 5.85794H4.51248V11.5421H0.977068V5.85794ZM9.01194 11.542H5.47665V5.85782H9.01206V11.5422L9.01194 11.542Z' />
    </SvgIcon>
  )
}

const SkillBiteItemIcon = ({ size, bgColor, Icon }) => {
  return (
    <Box sx={{ width: size, height: size, padding: '6px', borderRadius: '6px', backgroundColor: bgColor, mr: 1 }}>
      {Icon}
    </Box>
  )
}

export const CommitmentIcon = () => {
  return (
    <SkillBiteItemIcon
      size='36px'
      bgColor='#63AFED'
      Icon={<HandshakeRounded htmlColor='#FFF' />}
    />
  )
}

export const CommitmentCheckIcon = () => {
  return (
    <SkillBiteItemIcon
      size='36px'
      bgColor='#86B668'
      Icon={<LibraryAddCheckRounded htmlColor='#FFF' />}
    />
  )
}

export const TinyMceIcon = () => {
  return (
    <SkillBiteItemIcon
      size='36px'
      bgColor='#6787F7'
      Icon={<TinyMceSVGIcon htmlColor='#FFF' />}
    />
  )
}

export const DraftJSIcon = () => {
  return (
    <SkillBiteItemIcon
      size='36px'
      bgColor='#B27474'
      Icon={<DraftJSSVGIcon htmlColor='#FFF' />}
    />
  )
}

export const SessionIcon = () => {
  return (
    <SkillBiteItemIcon
      size='36px'
      bgColor='#4083F7'
      Icon={<BallotRounded htmlColor='#FFF' />}
    />
  )
}

export const SectionIcon = () => {
  return (
    <SkillBiteItemIcon
      size='30px'
      bgColor='#0C969C'
      Icon={<FeaturedPlayListRounded htmlColor='#FFF' fontSize='18px' />}
    />
  )
}
